import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import Form from "components/form/Form";
import { useForm } from "react-hook-form";
import FileUploadButton from "components/buttons/FileUploadButton";
import Button from "@mui/material/Button";
import { LoadingButton } from "@mui/lab";
import React, { useContext, useState } from "react";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import cookies from "js-cookie";

type CandidatesFromXlsxInputs = {
  file: File;
};

interface IUploadTemplateModalProps {
  open: boolean;
  onSuccess: () => void;
  handleClose: () => void;
}

const UploadTemplateModal = ({ open, onSuccess, handleClose }: IUploadTemplateModalProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const accessToken = cookies.get("accessToken");
  const companyId = cookies.get("companyId");
  const { addToast } = useContext(ToastContext);
  const form = useForm<CandidatesFromXlsxInputs>();
  const { handleSubmit } = form;

  const onError = () => addToast({ type: ToastTypeEnum.ERROR });

  const onSubmit = async (formData: CandidatesFromXlsxInputs) => {
    const data = new FormData();
    data.append("file", formData.file);

    setIsLoading(true);
    await fetch(`${process.env.REACT_APP_API_URL}/company-candidate/upload-from-xlsx`, {
      method: "POST",
      body: data,
      headers: {
        Authorization: `JWT ${accessToken}`,
        ...(companyId && { "company-id": companyId }),
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error();
        }

        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `${formData.file.name.replace(".xlsx", "")}-list.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);

        onSuccess();
        handleClose();
        addToast({ type: ToastTypeEnum.SUCCESS, text: "Шаблон обработан" });
      })
      .catch(() => addToast({ type: ToastTypeEnum.ERROR }))
      .finally(() => setIsLoading(false));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth='sm'>
      <DialogTitle
        variant='h24'
        textAlign='center'>
        Загрузка кандидатов
      </DialogTitle>
      <DialogContent>
        <Form form={form}>
          <Stack spacing={0.5}>
            <Typography
              variant='body14rg'
              sx={{ color: "base.500" }}>
              Шаблон кандидатов
            </Typography>
            <FileUploadButton
              name='file'
              label='Загрузить шаблон'
              accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
              rules={{ required: "Обязательное поле" }}
            />
          </Stack>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={handleClose}>
          Отмена
        </Button>
        <LoadingButton
          onClick={handleSubmit(onSubmit, onError)}
          loading={isLoading}
          variant='contained'>
          Загрузить
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default UploadTemplateModal;
